module.exports = __webpack_public_path__ + "img/group-active.7a50b1c9.svg";